// removed by extract-text-webpack-plugin
module.exports = {"root":"tve-provider__root","image":"tve-provider__image","logoutButton":"tve-provider__logoutButton","invert":"tve-provider__invert"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/tve-provider/styles.less
// module id = 167
// module chunks = 1 2